<!-- 登录(绑定角色) -->
<template>
  <popup-frame ref="popup" size="md">
    <div :class="$style.login">
      <bind-form ref="form" @bind-success="handleBindSuccess" />
    </div>
  </popup-frame>
</template>

<script>
import BindForm from './BindForm'
import { PopupFrame } from '@/components/widgets'

export default {
  name: 'TheLogin',
  components: { BindForm, PopupFrame },
  methods: {
    /**
     * 显示登录弹窗并初始化状态
     */
    show() {
      this.$refs.popup.show()
      // 重置表单
      if (this.$refs.form) this.$refs.form.reset()
    },
    /**
     * 登录后回调返回
     **/
    handleBindSuccess() {
      this.$refs.popup.hide()
      this.$emit('login-success')
    }
  }
}
</script>

<style lang="less" module>
.login {
  &::before {
    .size(7.08rem, 4.97rem);
    .background-fill('./images/title.png');

    content: '';
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
  }
}
</style>
